import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addincident } from "../redux/blacklist";

const IncidentDetails = () => {
    const [product, setProduct] = useState('');
    const [category, setCategory] = useState('');
    const [subcategory, setSubCategory] = useState('');
    const [subcategories, setSubCategories] = useState([]);
    const [incidentdate, setIncidentDate] = useState('');
    const [information, setInformation] = useState('');
    const [criminalCase, setCriminalCase] = useState(false);
    const [casenumber, setCaseNumber] = useState('');

    const [currencyApplied, setCurrencyApplied] = useState('R')
    const [currencyLost, setCurrencyLost] = useState('R')

    const [amountApplied, setAmountApplied] = useState('0')
    const [amountLost, setAmountLost] = useState('0')

    const [applied, setApplied] = useState('');
    const [lost, setLost] = useState('');


    const dispatch = useDispatch();

    const changeIncident = () => {
        dispatch(addincident({
            product,
            category,
            applied,
            lost,
            incidentdate,
            casenumber,
            information
        }))
    }

    useEffect(() => {
        setApplied(amountApplied)
        setLost(amountLost)
    }, [amountApplied, amountLost, currencyApplied, currencyLost])

    useEffect(() => {
        changeIncident()
    },[product,category, applied, lost, casenumber, incidentdate, information])


    const products = [
        "",
        "Purchase Order Financing", 
        "Invoice Discounting", 
        "Working Capital Loan", 
        "Home Loan", 
        "Secured Loan", 
        "Personal Loan", 
        "Vehicle Finance", 
        "Asset Finance", 
        "Other"
    ]

    // const categorymap = {
    //     '': ['Choose category...'],
    //     'Working capital': [
    //         'Shami add something',
    //         'Please add'
    //     ],
    //     'Purchase order financing': [
    //         'Shami needs to give more clarifications',
    //         'How am I supposed to know?'
    //     ],
    //     'False name and ID': [
    //         'False name and ID',
    //         'False name and address',
    //         'False ID and address',
    //         'False address',
    //         'Application details do not match',
    //         'Other'
    //     ],
    //     'Impersonation': [
    //         'False ID book',
    //         'Incorrect ID number',
    //         'Impersonation of another',
    //         'Use particulars of deceased',
    //         'Impersonation (Other)'
    //     ],
    //     'False employer details': [
    //         'Employer name incorrect',
    //         'Employer address incorrect',
    //         'Employer telephone number incorrect',
    //         'Forged or incorrect payslip',
    //         'Employer particulars (Other-Incorrect)'
    //     ],
    //     'Other forged documents': [
    //         'Forged documents',
    //         'False passport',
    //         'False or incorrect personal reference',
    //         'False or incorrect trade references',
    //         'Failure to disclose full details on an application',
    //         'Multiple forged documents',
    //         'False card drivers license',
    //         'False temporary driving license',
    //         'Other'
    //     ],
    //     'Misuse of account, through fraudulent conduct': [
    //         'Finance/loan accounts',
    //         'Retail accounts',
    //         'Telecoms accounts',
    //         'Banking accounts',
    //         'Debit orders',
    //         'ATM',
    //         'Evading liability (i.e. Confirmed fraud, not bad debt)',
    //         'Money Mules'
    //     ],
    //     'Employee/employment application fraud': [
    //         'Supply false ID/personnel particulars',
    //         'Aiding and abetting (Customer)',
    //         'Receive reward through inducement',
    //         'Aiding and abetting (Employee)',
    //         'Unlawful obtaining or disclosure of personnel data',
    //         'Account fraud',
    //         'Unlawful obtaining or disclosure of commercial data',
    //         'Dishonest action by staff to obtain a benefit by theft or fraud',
    //         'Corruption or collusion with other parties in corrupt practices',
    //         'Use of false information/qualifications in employment application',
    //         'Impersonation of an innocent party',
    //         'False immigration status',
    //         'Concealed or false employment history',
    //         'Concealed criminal convictions',
    //         'Concealed adverse financial/credit history'
    //     ],
    //     'Insurance fraud': [
    //         'Dishonest claim - motor vehicle theft',
    //         'Dishonest claim - motor vehicle accident',
    //         'Dishonest claim - death or disability',
    //         'Dishonest claim - retrenchment',
    //         'Inflated claim - motor vehicle',
    //         'Inflated claim - personal accident',
    //         'Dishonest claim - goods or services',
    //         'Inflated claim - goods or services',
    //         'Policy - entered into for fraudulent purposes'
    //     ],
    //     'Internet fraud': [
    //         'Internet shopping',
    //         'Internet banking',
    //         'Internet banking (Phishin)',
    //         'Internet banking (SIM swopping)',
    //         'Internet banking (Emule accounts)',
    //     ],
    //     'Business fraud/person unknown': [
    //         'Suspect syndicate address',
    //         'Suspect syndicate telephone',
    //         'Cheque fraud',
    //         'Credit card fraud',
    //         'Theft (Persona unknown)',
    //         'Forgery (Persona unknown)',
    //         'ATM Crime (Persona unknown)',
    //         'Suspect fraud other (Persona unknown)',
    //         'Corruption',
    //         'Advance fee fraud'
    //     ]
    // }

    const categories = [
        "",
        "Attempted Fraud", 
        "Scam Transaction", 
        "Impersonation", 
        "Forged Documents", 
        "Misuse of Accounts Fraudulently", 
        "Misuse of Funds Fraudulently", 
        "Evading Liability", 
        "Other"
    ]
    return ( 
        <div>
            <h2 className="display-6 text-center text-muted my-3">Incident Details</h2>

            
            
            <label for="reason" className="form-label">Listing reason:  <span className="text-danger">*</span></label>
            
            <select className="form-select w-75 mb-3" id="reason" defaultValue="Working capital" onChange={(e) => {
                setCategory(e.target.value)
            }} value={category}>
            {
                categories.map((item) => {
                    return (
                        <option value={item}>{item}</option>
                    )
                })
            }
            </select>

            <label htmlFor="product" className="form-label">Product: <span className="text-danger">*</span></label>
            <select name="product" id="product" className="form-select w-75" onChange={(e) => {
                setProduct(e.target.value)
            }} value={product}>
                {
                    products.map((item) => {
                        return (
                        <option value={item}>{item}</option>
                    )})
                }
            </select>

            <label class="form-label d-block" for="amount-applied">Amount applied for: </label>
            <div className="btn-group mb-3">
                    {/* <select name="amount-applied" className="form-select w-25 rounded-0 rounded-start" id="" onChange={(e) => {
                        setCurrencyApplied(e.target.value)

                    }}>
                        <option selected value="R">R</option>
                        <option value="$">$</option>
                        <option value="&#163;">&#163;</option>
                        <option value="&#8364;">&#8364;</option>
                        <option value="&#165;">&#165;</option>
                    </select> */}
                    <input type="number" id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setAmountApplied(String(e.target.value))
                    }}/>
            </div>

            <label class="form-label d-block" for="amount-lost">Amount lost: </label>
            <div className="btn-group mb-3">
                    {/* <select name="amount-lost" className="form-select w-25 rounded-0 rounded-start" id="" onChange={(e) => {
                        setCurrencyLost(e.target.value)

                    }}>
                        <option selected value="R">R</option>
                        <option value="$">$</option>
                        <option value="&#163;">&#163;</option>
                        <option value="&#8364;">&#8364;</option>
                        <option value="&#165;">&#165;</option>
                    </select> */}
                    <input type="number" id="ID" name="ID" className="form-control w-100 rounded-0 rounded-end" onChange={(e) => {
                        setAmountLost(String(e.target.value))
                    }}/>
            </div>

            <label class="form-label d-block" for="date">Incident date:  <span className="text-danger">*</span></label>
            <input type="date" class="form-control mb-3" id="date" name="date" placeholder="DD/MM/YYYY"
            onChange={(e) => {
                setIncidentDate(e.target.value)
            }}
            />



            <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(e) => {
                if (e.target.checked) {
                    setCriminalCase(true)
                } else {
                    setCriminalCase(false)
                }
            }}/>
            <label class="form-check-label" for="flexCheckDefault">
                Opened criminal case
            </label>
            </div>

            {
                criminalCase && 
                <div>
                    <label for="text" className="form-label">Case number:</label>
                    <input type="text" className="form-control mb-3"  onChange={(e) => {
                        setCaseNumber(e.target.value)
                    }}/>
                </div>
                
            }
            

            <label for="text" className="form-label">Further information (optional):</label>
            <textarea name="text" id="text" cols="30" rows="10" className="form-control" onChange={(e) => {
                setInformation(e.target.value)
            }
            }></textarea>
        </div>
     );
}
 
export default IncidentDetails;